(() => {
  const WALK_HANDLE = 'walk-explore-set';
  const HARNESS_HANDLE = 'soft-no-pull-cat-harness-leash-set-comfortable-adjustable-walking-vest-for-cats-small-dogs';
  const ADDON_VARIANT_ID = 52957379395901;
  const ADDON_PRICE_CENTS = 1999;
  const imageUrl = 'https://cdn.shopify.com/s/files/1/1013/7740/9341/files/ChatGPTImage2026_9_3_22_12_36.png?v=1788444955';
  const boundRoots = new WeakSet();
  let harnessProductPromise = null;

  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };

  const money = cents => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const cardMarkup = () => `
    <div class="pl-addon-wrap" data-addon-wrap>
      <span class="pl-addon-label">Optional Add-on</span>
      <article class="pl-addon" data-retractable-addon aria-label="10 ft Retractable Leash add-on">
        <div class="pl-addon__media"><img class="pl-addon__image" data-addon-image src="${imageUrl}" alt="10 ft Retractable Leash" loading="lazy"></div>
        <div class="pl-addon__body">
          <div class="pl-addon__top"><span class="pl-addon__title" data-addon-title>10 ft Retractable Leash</span><span class="pl-addon__price">$19.99</span></div>
          <p class="pl-addon__copy" data-addon-copy>Extra roaming range for everyday walks.</p>
          <label class="pl-addon__choice"><input type="checkbox" data-addon-choice aria-label="Add 10 ft Retractable Leash"><span class="pl-addon__check" aria-hidden="true"></span><span data-addon-action>Add</span></label>
        </div>
      </article>
      <p class="pl-addon__note" data-addon-note>You can add this 10 ft retractable leash to your cart with your set.</p>
    </div>`;

  const rootNode = () => document.querySelector('[data-powlife-product]') || document;

  const ensureCard = () => {
    const handle = currentHandle();
    if (![WALK_HANDLE, HARNESS_HANDLE].includes(handle)) return;
    const root = rootNode();
    if (root.querySelector('[data-retractable-addon]')) return;
    const form = root.querySelector('form.pl-buy__form') || root.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const addButton = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
    if (!addButton) return;
    addButton.insertAdjacentHTML('beforebegin', cardMarkup());
  };

  const applyCopyAndImage = () => {
    if (currentHandle() === WALK_HANDLE) {
      const tab = document.querySelector('[data-powlife-product] [data-story-tab="help"]');
      if (tab && tab.textContent.trim() !== 'Size Help') tab.textContent = 'Size Help';
    }
    document.querySelectorAll('[data-retractable-addon]').forEach(card => {
      const title = card.querySelector('[data-addon-title]');
      if (title) title.textContent = '10 ft Retractable Leash';
      const copy = card.querySelector('[data-addon-copy]');
      if (copy) copy.textContent = 'Extra roaming range for everyday walks.';
      const image = card.querySelector('[data-addon-image]');
      if (image) {
        if (image.src !== imageUrl) image.src = imageUrl;
        image.alt = '10 ft Retractable Leash';
        image.hidden = false;
        image.style.display = 'block';
      }
    });
  };

  const syncAddonState = root => {
    const input = root.querySelector('[data-addon-choice]');
    const checked = !!input?.checked;
    root.querySelectorAll('[data-retractable-addon]').forEach(card => {
      card.classList.toggle('is-selected', checked);
      card.setAttribute('aria-label', checked ? '10 ft Retractable Leash added' : '10 ft Retractable Leash add-on');
      card.setAttribute('aria-selected', checked ? 'true' : 'false');
      const action = card.querySelector('[data-addon-action]');
      if (action) action.textContent = checked ? 'Added ✓' : 'Add';
    });
    const note = root.querySelector('[data-addon-note]');
    if (note && input) {
      note.textContent = checked ? 'Added to your set (+$19.99).' : 'You can add this 10 ft retractable leash to your cart with your set.';
      note.style.color = '';
    }
  };

  const fetchHarnessProduct = () => {
    if (!harnessProductPromise) {
      harnessProductPromise = fetch(`/products/${HARNESS_HANDLE}.js`, { credentials:'same-origin', headers:{ Accept:'application/json' } }).then(response => {
        if (!response.ok) throw new Error('Unable to load harness pricing');
        return response.json();
      });
    }
    return harnessProductPromise;
  };

  const refreshHarnessPrice = async root => {
    if (currentHandle() !== HARNESS_HANDLE) return;
    const price = root.querySelector('[data-product-price]');
    const variantInput = root.querySelector('[data-variant-select]') || root.querySelector('[name="id"]');
    const addon = root.querySelector('[data-addon-choice]');
    const variantId = Number(variantInput?.value);
    if (!price || !variantId) return;
    try {
      const product = await fetchHarnessProduct();
      const variant = product?.variants?.find(v => Number(v.id) === variantId) || product?.variants?.[0];
      if (!variant) return;
      price.textContent = money(Number(variant.price || 0) + (addon?.checked ? ADDON_PRICE_CENTS : 0));
    } catch (error) {
      console.warn('[Retractable Add-on price]', error);
    }
  };

  const bindAddonUi = () => {
    const root = rootNode();
    if (!root || boundRoots.has(root)) return;
    boundRoots.add(root);
    root.addEventListener('change', event => {
      if (!event.target.matches?.('[data-addon-choice]')) return;
      syncAddonState(root);
      if (currentHandle() === HARNESS_HANDLE) refreshHarnessPrice(root);
    });
    root.querySelector('[data-variant-select]')?.addEventListener('change', () => {
      if (currentHandle() === HARNESS_HANDLE) setTimeout(() => refreshHarnessPrice(root), 0);
    });
  };

  const showAddonMessage = (form, message, isError = false) => {
    const note = form.querySelector('[data-addon-note]');
    if (!note) return;
    note.textContent = message;
    note.dataset.addonError = isError ? '1' : '0';
    note.style.color = isError ? '#b42318' : '';
  };

  const waitForCartApi = async () => {
    for (let i = 0; i < 20; i += 1) {
      if (window.HipipetCartDrawerApi?.addItems) return window.HipipetCartDrawerApi;
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    throw new Error('Cart is still loading. Please try again.');
  };

  const bindHarnessAddon = () => {
    if (currentHandle() !== HARNESS_HANDLE) return;
    const root = rootNode();
    const form = root.querySelector('form.pl-buy__form') || root.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.retractableAddonBound === '1') return;
    form.dataset.retractableAddonBound = '1';
    form.addEventListener('submit', async event => {
      const addon = form.querySelector('[data-addon-choice]');
      if (!addon?.checked) return;
      const variantInput = form.querySelector('[data-variant-select]') || form.querySelector('[name="id"]');
      const mainId = Number(variantInput?.value);
      if (!mainId) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const submit = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type="submit"]');
      if (submit) submit.disabled = true;
      showAddonMessage(form, 'Adding both items to your cart…');
      try {
        const api = await waitForCartApi();
        await api.addItems([
          { id: mainId, quantity: 1 },
          { id: ADDON_VARIANT_ID, quantity: 1 }
        ], {
          sourceEl: form,
          sourceId: form.id || '',
          productId: document.querySelector('[data-powlife-product]')?.dataset.productId || ''
        });
        showAddonMessage(form, 'Added to cart.');
      } catch (error) {
        console.error('[Retractable Add-on]', error);
        showAddonMessage(form, error?.message || 'Unable to add the retractable leash. Please try again.', true);
      } finally {
        if (submit) submit.disabled = false;
      }
    }, true);
  };

  const applyAll = () => {
    ensureCard();
    applyCopyAndImage();
    bindAddonUi();
    bindHarnessAddon();
    const root = rootNode();
    syncAddonState(root);
    if (currentHandle() === HARNESS_HANDLE) refreshHarnessPrice(root);
  };

  const boot = () => {
    applyAll();
    requestAnimationFrame(applyAll);
    setTimeout(applyAll, 250);
  };

  if (document.readyState === 'loading') {
    boot();
    document.addEventListener('DOMContentLoaded', boot, { once:true });
  } else boot();
  document.addEventListener('shopify:section:load', boot);
})();